import isoCountries from 'i18n-iso-countries'
import en from 'i18n-iso-countries/langs/en.json'
import es from 'i18n-iso-countries/langs/es.json'

isoCountries.registerLocale(en)
isoCountries.registerLocale(es)

export default isoCountries
